import { useContext } from 'react';

import { ModalContext } from '../providers/ContextProvider';

export const useModalContext = () => {
  return useContext(ModalContext);
};
